<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete"
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewTrigger" class="btn btn-primary">
              Create Trigger
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert 
          :type="message.type" 
          :dismissible="true"
          @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
            <template slot="trigger_type_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> UGC Artwork Image </label>
            <label v-if="props.cell_value == 1"> UGC Artwork Image - Vote Approved</label>
            <label v-if="props.cell_value == 2"> Spin Wheel - Custom Prize</label>
            <label v-if="props.cell_value == 3"> UPC Input</label>
            <label v-if="props.cell_value == 4"> User Login</label>
            <label v-if="props.cell_value == 5"> Donations</label>
            <label v-if="props.cell_value == 6"> Xth Number of UPC</label>  
            <label v-if="props.cell_value == 9"> Double SpinWheel</label>
            <label v-if="props.cell_value == 10"> Redeem Item On Event</label>
            <label v-if="props.cell_value == 99"> Others </label>
          </template>
          
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.trigger_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Trigger Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select brand"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="form-control-label"> Promotion Type</label>
            <model-list-select
              :list="allPromoType"
              v-model="watch_promo_type"
              option-value="value"
              option-text="text"
              placeholder="select promo type"
              :isDisabled="isPromoTypeDisabled"
            >
            </model-list-select>            
          </div>
        </div >
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Trigger Name"
              input-classes="form-control"
              v-model="triggerModel.trigger_name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="form-control-label"> Trigger Type</label>
            <model-list-select
              :list="selectedTriggerType"
              v-model="triggerModel.trigger_type"
              option-value="value"
              option-text="text"
              placeholder="Trigger type"
            >
            </model-list-select> 
          </div>
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="Trigger Value"
              input-classes="form-control"
              v-model="triggerModel.trigger_value"
              v-if="hideTriggerValue"
            />
          </div>
        </div>
        <div class="row" v-if="hideFieldSku">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="SKU"
              input-classes="form-control"
              v-model="triggerModel.sku"
            />
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdateTrigger"
          class="btn btn-primary"
          v-bind:disabled="disableButtonSubmit"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
// import BaseCheckbox from '../components/BaseCheckbox.vue';


export default {
  name: "TriggerItemList",
  data() {
    return {
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      allPromoType: [
        { text: "UGC Artwork Image", value: "0" },
        { text: "UGC Artwork Image - Vote Approved", value: '1', promotype:'1' },
        { text: "Spin Wheel - Custom Prize", value: '2' },
        { text: "UPC Input - Lifetime", value: '3' },
        { text: "UPC Custom Insert", value: '4' },
        { text: "MGM Major Prize", value: '5' },
        { text: "MGM Minor Prize", value: '6' },
        { text: "Custom Returnee", value: '7' },
        { text: "Donations", value: '8' },
        { text: "UPC Input Regular", value: '9' },
        { text: "Cash or Bukash", value: '11' },
        { text: "Progressive MGM", value: '12' },
        { text: "Redeem Item", value: '13' },
        { text: "Lucky Promo", value: '14' },
        { text: "Roulette", value: '15' },
        { text: "Daily Login", value: '16' },
        { text: "Auto Awarding Birthday User", value: '17' },
        { text: "Auto Awarding Anniversary", value: '18' },
        { text: "Double SpinWheel", value: '19' },
        { text: "Redeem Item On Event", value: '20' },
        { text: "Daily Check In", value: '25' },
        { text: "Beats Game", value: "30" },
        { text: "Catch Game", value: "31" },
        { text: "Chest Prize", value: '40' },
        { text: "Lucky Promo With SKU", value: '45' },
        { text: "UPC Custom Insert With Raffle", value: '50' }
      ],
      allTriggerType: [
        { text: "UGC Artwork Image", value: '0', promotype:['0'] },
        { text: "UGC Artwork Image - Vote Approved", value: '1', promotype:['1']  },
        { text: "Spin Wheel - Custom Prize", value: ['2']  },
        { text: "UPC Input", value: '3', promotype:['3','4','5','6','9','12', '50']},
        { text: "User Login", value: '4', promotype:['7', '16', '17', '18', '25'] },
        { text: "Donations", value: '5', promotype:['8']},
        { text: "Xth number of upc", Value:'6', promotype:['11','14','45']},
        { text: "Redeem Item", value: '7', promotype:['13'] },
        { text: "Roulette", value: '8', promotion_type: ['15'] },
        { text: "Double SpinWheel", value: '9', promotype: ['19'] },
        { text: "Redeem Item On Event", value: '10', promotype: ['20'] },
        { text: "Beats Game", value: '11', promotype: ['30'] },
        { text: "Catch Game", value: '12', promotype: ['31'] },
        { text: "Chest Prize", value: '15', promotype: ['40'] },
        { text: "Others", value: "99" , promotype:['99']}
      ],
      selectedTriggerType: [],
      showActionEdit: false,
      isBrandCodeDisabled: false,
      isPromoTypeDisabled: false,
      showActionDelete: false,
      brandCodeOption: [],
      watch_promo_type: "0",
      watch_trigger_type : "",
      titlePopup: "Create",
      message: null,
      triggerModel: {
        brand_code: "PHFortune",
        trigger_name: "",
        promotion_type: "0",
        trigger_type: "",
        trigger_value: "",
        sku: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allTriggerConfigs: null,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Trigger Name",
          name: "trigger_name",
          sort: true,
        },
        {
          label: "Promotion Type",
          name: "promotion_type_name",
          sort: true,
          filter: {
            type: "simple",
            placeholder: "Enter Promotion Type Name",
            case_sensitive: false, // "false" by default
            showClearButton: true,
            filterOnPressEnter: false,
            debounceRate: 500,
          }          
        },
        {
          label: "Trigger Type",
          name: "trigger_type",
          slot_name: "trigger_type_column",
          sort: true,
        },
        {
          label: "Trigger Value",
          name: "trigger_value",
          sort: true,
        },
        {
          label: "SKU",
          name: "sku",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.isBrandCodeDisabled = false;
    this.isPromoTypeDisabled = false;
    this.onRefreshData();
    var trigger_type_items = []

    this.allTriggerType= [
        { text: "UGC Artwork Image", value: '0', promotype:['0'] },
        { text: "UGC Artwork Image - Vote Approved", value: '1', promotype:['1'] },
        { text: "Spin Wheel - Custom Prize", value: '2',promotype:['2']  },
        { text: "UPC Input", value: '3', promotype:['3','4','5','6','9','12', '50']},
        { text: "User Login", value: '4', promotype:['7', '16', '17', '18', '25'] },
        { text: "Donations", value: '5', promotype:['8']},
        { text: "Xth number of upc", value: '6', promotype:['11','14','45']},
        { text: "Redeem Item", value: '7', promotype:['13'] },
        { text: "Roulette", value: '8', promotype:['15'] },
        { text: "Double SpinWheel", value: '9', promotype:['19'] },
        { text: "Redeem Item On Event", value: '10', promotype:['20'] },
        { text: "Beats Game", value: '11', promotype: ['30'] },
        { text: "Catch Game", value: '12', promotype: ['31'] },
        { text: "Chest Prize", value: '15', promotype: ['40'] },
        { text: "Others", value: "99" , promotype:['99']}
    ];

    if (this.watch_brand_code == "PHChe") {
      this.allTriggerType = [...this.allTriggerType]
    }

    this.triggerModel.promotion_type = "0";

    this.allTriggerType.forEach(function (item) {
      if(item.value ==  "0" ){
        trigger_type_items.push(item);
      }
    });
    this.selectedTriggerType = trigger_type_items;

  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('triggerconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('triggerconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    ValidateForm() {      
    if (
      this.triggerModel.brand_code &&
      this.triggerModel.trigger_name &&
      this.triggerModel.promotion_type &&
      this.triggerModel.trigger_type &&
      this.triggerModel.trigger_value &&
      this.triggerModel.sku
    ) {
      return true;
    }
    return false;
  },
    onResetForm() {
      this.triggerModel = {
        brand_code: this.watch_brand_code,
        trigger_name: "",
        promotion_type: "0",
        trigger_type: "",
        trigger_value: "",
        sku: "",
      };
      this.isBrandCodeDisabled=false,
      this.isPromoTypeDisabled=false;
      this.watch_promo_type= "0";
      this.watch_trigger_type = "";
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onCreateNewTrigger() {
      var trigger_type_items = []
      this.showModalCreate = true;
      this.isBrandCodeDisabled = false;
      this.isPromoTypeDisabled=false;
      this.titlePopup = "Create";
      this.onResetForm();
      this.allTriggerType.forEach(function (item) {
        if(item.promotype == "0" ){
          trigger_type_items.push(item);
        }
      });
      this.selectedTriggerType = trigger_type_items;

    },
    toggleActive() {},
    async onRefreshData() {
    api_loyalty
      .GetAllTrigger(this.watch_brand_code)
      .then((data) => {
        try {
          if(data.isSuccess)
          {
            data.data.forEach(function (item){
              switch(item.promotion_type){
                case "0": item.promotion_type_name = "UGC Artwork Image"; break;
                case "1": item.promotion_type_name = "UGC Artwork Image - Vote Approved"; break;
                case "2": item.promotion_type_name = "Spin Wheel - Custom Prize"; break;
                case "3": item.promotion_type_name = "UPC Input - Lifetime"; break;
                case "4": item.promotion_type_name = "UPC Custom Insert"; break;
                case "5": item.promotion_type_name = "MGM Major Prize"; break;
                case "6": item.promotion_type_name = "MGM Minor Prize"; break;
                case "7": item.promotion_type_name = "Custom Returnee"; break;
                case "8": item.promotion_type_name = "Donations"; break;
                case "9": item.promotion_type_name = "UPC Insert Regular"; break; 
                case "11": item.promotion_type_name = "Cash or Bukash"; break;              
                case "12": item.promotion_type_name = "Progressive MGM"; break;   
                case "13": item.promotion_type_name = "Redeem Item"; break;
                case "14": item.promotion_type_name = "Lucky Promo"; break;
                case "15": item.promotion_type_name = "Roulette"; break;
                case "16": item.promotion_type_name = "Daily Login"; break;
                case "17": item.promotion_type_name = "Auto Awarding Birthday User"; break;
                case "18": item.promotion_type_name = "Auto Awarding Anniversary"; break;
                case "19": item.promotion_type_name = "Double SpinWheel"; break;
                case "20": item.promotion_type_name = "Redeem Item On Event"; break;
                case "25": item.promotion_type_name = "Daily Check In"; break;
                case "30": item.promotion_type_name = "Beats Game"; break;
                case "31": item.promotion_type_name = "Catch Game"; break;
                case "40": item.promotion_type_name = "Chest Prize"; break;
                case "45": item.promotion_type_name = "Lucky Promo With SKU"; break;
                case "50": item.promotion_type_name = "UPC Custom Insert With Raffle"; break;
              }
            });          
            this.rows = data.data;
            this.allTriggerConfigs = data.data;
            this.hideTriggerValue();
          }
        } catch (e) {
          console.log(e);
        }
    });
      this.watch_promo_type= "0";
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.triggerModel = Object.assign(
        this.triggerModel,
        this.allTriggerConfigs.find(
          (x) => x.id === this.selectedItems[0].id
        ) ?? {}
      );
      this.watch_promo_type = this.triggerModel.promotion_type;
      this.watch_trigger_type  = this.triggerModel.trigger_type;
      this.isBrandCodeDisabled = true;
      this.isPromoTypeDisabled = true;
      this.showModalCreate = true;
      this.titlePopup = "Update";
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.triggerModel.id = deleteRequest.id;
        this.triggerModel.brand_code = this.watch_brand_code;

        api_loyalty
          .DeleteGlobalPromoTrigger(this.triggerModel, this.triggerModel.brand_code)
          .then((response) => {
            this.onRefreshData();

            var popupType = "success"
            if(response.isSuccess == false){
              popupType = "danger";
            }

            let msg = {
              message:
              response.message + " : " + element.trigger_name + "'.",
              type: popupType,
            };
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete trigger '" +
                element.trigger_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    async createUpdateTrigger() {
      if (this.triggerModel.id) {
        this.triggerModel.modify_date = new Date().toISOString();
        this.triggerModel.brand_code = this.watch_brand_code;

        api_loyalty
        .UpdateGlobalPromoTrigger(this.triggerModel.brand_code, this.triggerModel)
        .then((response) => {
          this.onRefreshData();

          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 401)
          {
            this.message = {
              message: "You don't have a permission",
              type: 'danger'
            }
          } else
          {
            this.message = {
              message: "Failed to update Triggger Item Config.",
              type: "danger",
            }
          }          
        });
      } else {
        this.triggerModel.brand_code = this.watch_brand_code;
        api_loyalty
        .AddGlobalPromoTrigger(this.triggerModel.brand_code, this.triggerModel)
        .then((response) => {
          this.onRefreshData();

          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

           this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 401)
          {
            this.message = {
              message: "You don't have a permission",
              type: 'danger'
            }
          } else
          {
            this.message = {
              message: "Failed to create Triggger Item.",
              type: "danger",
            }
          }
        });
      }

       this.onResetForm();
       this.showModalCreate = false;
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    // BaseCheckbox,
  },
  watch: {
    watch_brand_code: function(val) {
      this.triggerModel.brand_code = this.watch_brand_code;
      switch (val) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
      this.onRefreshData();
    },
    watch_promo_type: function (val) {
      var trigger_type_items = []      
      this.triggerModel.trigger_type = "";
      this.triggerModel.promotion_type = val;

      this.allTriggerType.forEach(function (item) {
        if(item.promotype.indexOf(val) !== -1){
          trigger_type_items.push(item);
        }
      });
      this.selectedTriggerType = trigger_type_items;
    },
    watch_trigger_type: function (val) {
      this.triggerModel.trigger_type = val;
    }
  },
  computed: {
    disableButtonSubmit: function () {
      let isDisabled = false;
      
      // Check if all basic required fields are filled
      if (this.triggerModel.trigger_name && 
          this.triggerModel.brand_code && 
          this.triggerModel.promotion_type && 
          this.triggerModel.trigger_type) {

        isDisabled = false;                
        // SKU validation - mandatory only for Lucky Promo with SKU (45)
        if (this.triggerModel.promotion_type === "45") {
          if (!this.triggerModel.sku || this.triggerModel.sku.trim() === "") {
            isDisabled = true;
          }
        }
        
      } else {
        isDisabled = true;
      }
      
      return isDisabled;
    },
    hideFieldSku: function () {
      let isShow= true;
       if(this.triggerModel.promotion_type == "3" || this.triggerModel.promotion_type == "11" || this.triggerModel.promotion_type == "45")
        {
          isShow = true;
        }
        else
        {
          isShow = false;
        }
      return isShow;
    },
    hideTriggerValue: function ()
    {
      let isShow = true;
      if (this.triggerModel.promotion_type == "15")
      {
        isShow = false;
      }
      else
      {
        isShow = true;
      }
      return isShow;
    }
  }
};
</script>
<style>
</style>

